import React, { Component } from 'react';
import { translateProperty } from '../../../../util';
import { HtmlComponent } from '../../../../components';
import { PropTypes } from 'prop-types';

export class ViewItem extends Component {
  render() {
    const { properties, value, title } = this.props;
    const translated = title || translateProperty( properties, value );

    return <HtmlComponent className="listbox-content-text" tooltip={ translated } item={ translated } />;
  }
}

ViewItem.propTypes = {
  properties: PropTypes.shape( {} ),
  value: PropTypes.string.isRequired,
  title: PropTypes.string
};